import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Configuration } from '../../app.constants';
@Injectable()
export class StaticValueService {
  public staticData: any;
  public errors: any;
    public language = 'english';
  constructor(
    private router: Router,
    private _http: HttpClient,
    private config: Configuration
  ) { }

  public getStaticValues(): Promise<any> {
      return new Promise((resolve, reject) => {
          if (!this.staticData) {
              this._http.get(`${this.config.ServerApiUrl}/getStaticData`).subscribe(
                  (data) => {
                    this.staticData = data['staticValues'];
                    this.errors = data['errors'];
                    // console.log('THis is the static data',this.staticData);
                      resolve(this.staticData);
                  }, (err) => {
                      console.log('error in fetching static data service')
                      reject(err);
                  });
          } else {
              resolve(this.staticData);
          }
  });
}

public getErrors(): Promise<any> {
    return new Promise((resolve, reject) => {
        if (!this.errors) {
            this._http.get(`${this.config.ServerApiUrl}/getStaticData`).subscribe(
                (data) => {
                    this.staticData = data['staticValues'];
                    this.errors = data['errors'];
                    resolve(this.errors);
                }, (err) => {
                    console.log('error in fetching static error service')
                    reject(err);
                });
        } else {
            resolve(this.errors);
        }
});
}

setLanguage(lang: any) {
   this.language = lang;
}
getLanguage() {
    return this.language;
}

}
